import { message } from 'antd';
import { domainUrl } from '../../constants';
import { checkAuthorization } from '../../helpers';

const listVersions = (params = {}) => {
  const { userToken } = checkAuthorization();
  const sp = new URLSearchParams();
  if (params.active_only != null) sp.set('active_only', params.active_only);
  if (params.limit != null) sp.set('limit', params.limit);
  const qs = sp.toString();
  const url = domainUrl + '/listVersions' + (qs ? '?' + qs : '');
  return fetch(url, {
    method: 'GET',
    headers: { Authorization: userToken },
    redirect: 'follow',
  })
    .then((res) => {
      if (res.status !== 200) throw 'auth error';
      return res.json();
    })
    .then((data) => {
      if (data?.success) return data;
      throw data?.message || 'List failed';
    })
    .catch((err) => {
      message.error(typeof err === 'string' ? err : 'List failed');
      return { success: false, data: [], count: 0 };
    });
};

const uploadApk = (formData, onProgress) => {
  const { userToken } = checkAuthorization();
  const body = new FormData();
  body.append('apk_file', formData.apk_file);
  body.append('version_code', formData.version_code);
  body.append('version_name', formData.version_name);
  if (formData.release_notes != null && formData.release_notes !== '') body.append('release_notes', formData.release_notes);
  body.append('force_update', formData.force_update === true ? '1' : '0');

  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', domainUrl + '/uploadApk');
    xhr.setRequestHeader('Authorization', userToken);

    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable && typeof onProgress === 'function') {
        const percent = Math.round((e.loaded / e.total) * 100);
        onProgress(percent);
      }
    };

    xhr.onload = () => {
      try {
        const data = JSON.parse(xhr.responseText || '{}');
        if (data?.success) {
          message.success(data?.message || 'APK uploaded successfully');
          resolve(data);
        } else {
          resolve({
            success: false,
            errors: data?.errors || null,
            message: data?.message || 'Upload failed',
          });
        }
      } catch {
        message.error('Upload failed');
        resolve(null);
      }
    };

    xhr.onerror = () => {
      message.error('Upload failed');
      resolve(null);
    };

    xhr.send(body);
  });
};

const downloadApk = (filename) => {
  const { userToken } = checkAuthorization();
  const url = domainUrl + '/downloadApk/' + encodeURIComponent(filename);
  return fetch(url, {
    method: 'GET',
    headers: { Authorization: userToken },
    redirect: 'follow',
  })
    .then((res) => {
      if (!res.ok) throw new Error('Download failed');
      return res.blob();
    })
    .then((blob) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = filename || 'app.apk';
      a.click();
      URL.revokeObjectURL(a.href);
    })
    .catch((err) => {
      message.error(err?.message || 'Download failed');
    });
};

const OtaUpdateApi = { listVersions, uploadApk, downloadApk };
export { OtaUpdateApi };
